import { MODES_2D_VIEWER } from '@constants'
import { Modes } from '@types'

export default function is2DMode(mode: Modes) {
  return MODES_2D_VIEWER.includes(mode)
}
